import { forwardRef, useId, type InputHTMLAttributes, type ReactNode } from "react";
import styles from "./Checkbox.module.css";

interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "type" | "id"> {
  label: ReactNode;
  error?: string;
}

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(function Checkbox(
  { label, error, className, ...rest },
  ref,
) {
  const id = useId();
  return (
    <div className={styles.wrap}>
      <label className={styles.row} htmlFor={id}>
        <input
          ref={ref}
          id={id}
          type="checkbox"
          className={styles.input}
          aria-invalid={error ? true : undefined}
          {...rest}
        />
        <span className={[styles.box, error ? styles.invalid : ""].filter(Boolean).join(" ")} aria-hidden="true">
          <svg viewBox="0 0 16 16" width="12" height="12" fill="none" className={styles.tick}>
            <path d="M3 8.5l3 3 7-7.5" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </span>
        <span className={styles.label}>{label}</span>
      </label>
      {error && (
        <p className={styles.error} role="alert">
          {error}
        </p>
      )}
    </div>
  );
});
